import {ip_back , api_key} from '../constants/appConstants';

const API_URL = ip_back + '/api/polizas';


export const listar_Polizas = async (filtros=null) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const params = new URLSearchParams();
      if (filtros.cliente && filtros.cliente!=='-1') params.append("cliente", filtros.cliente);
      if (filtros.compania && filtros.compania!=='-1') params.append("compania", filtros.compania);
      if (filtros.ramo && filtros.ramo!=='-1') params.append("ramo", filtros.ramo);
      if (filtros.fch_ini_ven && filtros.fch_ini_ven!=='-1'){
        const [year, month, day] = filtros.fch_ini_ven.split('-');
        const formattedDate = `${day}/${month}/${year}`;
        params.append("fecha_desde", formattedDate);
      } 
      if (filtros.fch_fin_ven && filtros.fch_fin_ven!=='-1'){
        const [year, month, day] = filtros.fch_fin_ven.split('-');
        const formattedDate = `${day}/${month}/${year}`;
        params.append("fecha_hasta", formattedDate);
      }
      const response = await fetch(`${API_URL}/listar?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error('Error al listar pólizas');
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const obtenerPoliza = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/obtener?id=${id}`, {        
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error(`Error al obtener la póliza: ${id}`);
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const crearPoliza = async (formData, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "numero" : formData.numero, "compania" : formData.compania ,"cliente" : formData.cliente, "valor" : formData.valor, "fechaEmision": formData.fechaEmision, "fechaVencimiento": formData.fechaVencimiento, "ramo": formData.ramo, "valorPrima" : formData.valorPrima, "porcentaje" : formData.porcentaje, "creador" : creador}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarPoliza = async (formData, editor, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "id": id, "numero" : formData.numero, "compania" : formData.compania ,"cliente" : formData.cliente, "valor" : formData.valor, "fechaEmision": formData.fechaEmision, "fechaVencimiento": formData.fechaVencimiento, "ramo": formData.ramo, "valorPrima" : formData.valorPrima, "porcentaje" : formData.porcentaje, "editor" : editor}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarPoliza = async (id, editor) => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${API_URL}/eliminar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "id" : id, "editor" : editor}),
        });
          return response;
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
};

export const agregarTelefono = async (formData, id, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/agregar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "cliente" : id, "telefono" : formData.telefono, "creador" : creador , "descripcion" : formData.descripcion}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarTelefono = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id": formData.id, "telefono": formData.telefono, "editor": editor, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarTelefono = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const agregarCorreo = async (formData, cliente, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/agregar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "cliente": cliente, "correo": formData.correo, "creador": creador, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarCorreo = async (formData, editor) => {
  try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/actualizar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id": formData.id, "correo": formData.correo, "editor": editor, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarCorreo = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const listarDocumentos = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/listarDocumentos?poliza=${id}`, {        
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) {
        if (response.status === 404) {
          return [];
        }
      }
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const eliminarDocumento = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminarDocumento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const agregarDocumento = async (formData, poliza, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/subirDocumento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "creador": creador, "tipo": formData.tipo, "extension": formData.extension, "nombre": formData.nombre, "contenido": formData.contenido, "poliza": poliza }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarDocumento = async (formData, editor, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizarDocumento`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "editor": editor, "id": id, "extension": formData.extension, "nombre": formData.nombre, "contenido": formData.contenido }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};